export interface MitToReconEstimateGeneratedProps {
  source_estimate_id: string;
}

export const MIT_TO_RECON_EVENTS = {
  GENERATED: "mit_to_recon_estimate_generated",
} as const;

export interface MitToReconEventPropertiesMap {
  [MIT_TO_RECON_EVENTS.GENERATED]: MitToReconEstimateGeneratedProps;
}
